import { utilsModule } from "../utils-module";

utilsModule.factory('currentOrderType',['OrderTypeService','$transitions',function(OrderTypeService,$transitions){
  
  var orderTypeInstance = OrderTypeService.createOrderTypeInstance(undefined);

  $transitions.onStart({}, function(trans) {
		if(trans.to().url.indexOf("/packing/") > -1){
			orderTypeInstance.type = "PACKING";
		}else if(trans.to().url.indexOf("/tags/") > -1){
			orderTypeInstance.type = "TAGS";
		}else if(trans.to().url.indexOf("/modules-menu") > -1){
			orderTypeInstance.type = "MENU";
		}
	})

  return orderTypeInstance;

}])
